import { render, staticRenderFns } from "./EmptyStateInput.vue?vue&type=template&id=45628897&"
import script from "./EmptyStateInput.vue?vue&type=script&lang=js&"
export * from "./EmptyStateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports